import React from 'react';

import Card from '@mui/material/Card';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import NotesComponent from '../shared/NotesComponent';

function WarranteeNotes(props) {
  // console.log('NOTES PROPS: ', props);
  const warranteeId = props.warranteeId;
  const relationType = 'warranteeTable';
  return (
    <Card
      style={{
        // marginLeft: '-10px',
        textAlign: 'left',
        marginTop: '10px',
        boxShadow: 'none',
        background: '#ff00ff',
      }}
    >
      <Accordion sx={{ background: '#b9c9d9' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        >
          <Typography variant='h5'>Notes</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <NotesComponent
            relationId={warranteeId}
            relationType={relationType}
          />
        </AccordionDetails>
      </Accordion>

      {/* <TextField
        style={{ width: '98%', margin: 0 }}
        id='outlined-multiline-static'
        variant='outlined'
        multiline
        rows={5}
        defaultValue={customerId}
      />*/}
    </Card>
  );
}

export default WarranteeNotes;
